var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAutomatedCampaignsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4502 14.375C20.7002 16.6415 19.3667 18.4707 17.4502 19.8623C15.5335 21.254 13.3833 21.9502 11 21.9502C9.20003 21.9502 7.51248 21.5379 5.9375 20.7129C4.3625 19.8879 3.05 18.7333 2 17.25V19.9502H0V13.9502H6V15.9502H3.5498C4.39974 17.2001 5.47891 18.1794 6.78711 18.8877C8.09544 19.596 9.5 19.9502 11 19.9502C12.9167 19.9502 14.6546 19.3998 16.2129 18.2998C17.771 17.1998 18.8667 15.7413 19.5 13.9248L21.4502 14.375Z",
    fill: "#5F11EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9629 15.7295L10.8887 13.1914H10.0742V16.5762H8.44434V13.1914H7.62988C7.18173 13.1914 6.79765 13.0257 6.47852 12.6943C6.15941 12.3629 6 11.9644 6 11.499V9.80664C6.00003 9.34131 6.15941 8.94271 6.47852 8.61133C6.79765 8.27994 7.18175 8.11426 7.62988 8.11426H10.8887L14.9629 5.57617V15.7295Z",
    fill: "#5F11EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7773 7.81836C16.144 8.15681 16.44 8.56914 16.6641 9.05566C16.8881 9.5422 17 10.0751 17 10.6533C16.9999 11.2313 16.8881 11.7636 16.6641 12.25C16.44 12.7365 16.144 13.1488 15.7773 13.4873V7.81836Z",
    fill: "#5F11EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.3252C3.46668 6.00851 3.03352 6.73772 2.7002 7.5127C2.36686 8.28769 2.15853 9.1002 2.0752 9.9502H0.0498047C0.166471 8.83353 0.432943 7.7623 0.849609 6.7373C1.26627 5.71239 1.84192 4.767 2.5752 3.90039L4 5.3252Z",
    fill: "#5F11EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4502 3.90039C20.1833 4.76689 20.7582 5.71254 21.1748 6.7373C21.5915 7.7623 21.8502 8.83353 21.9502 9.9502H19.9502C19.8669 9.10022 19.6585 8.28767 19.3252 7.5127C18.9919 6.73777 18.5587 6.00847 18.0254 5.3252L19.4502 3.90039Z",
    fill: "#5F11EA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C9.15009 2.08332 8.34179 2.29173 7.5752 2.625C6.80869 2.95826 6.0836 3.39163 5.40039 3.9248L3.97461 2.5C4.85794 1.76667 5.80853 1.1877 6.8252 0.762695C7.84181 0.337737 8.90006 0.0833288 10 0V2Z",
    fill: "#5F11EA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C13.1167 0.1 14.1879 0.358724 15.2129 0.775391C16.2377 1.19201 17.1833 1.76685 18.0498 2.5L16.625 3.9248C15.9417 3.39154 15.2124 2.9583 14.4375 2.625C13.6625 2.29168 12.85 2.08333 12 2V0Z",
    fill: "#5F11EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAutomatedCampaignsActive);
export default __webpack_public_path__ + "static/media/icon-automated-campaigns-active.11d44f57b6373e637447d65b8d77f9ee.svg";
export { ForwardRef as ReactComponent };